import EventEmitter from "eventemitter3";
import { Data } from "../../../models/data";
import { Page } from "../page";
import { Context } from "../../../models/context";
import { LocalizationService } from "../../../services/localization-service";

export class Terms extends Page {
    constructor(eventBus: EventEmitter, data: Data, context: Context, localizationService: LocalizationService) {
        super("page_terms", eventBus, data, context, localizationService);
    }

    public async initAsync(): Promise<void> { }
}